export const queryToString = (query: Record<string, string | string[] | undefined>) => {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (!value) return;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        params.append(key, v);
      });
    } else {
      params.append(key, value);
    }
  });

  return params.toString();
};

export const stringToQuery = (queryString: string) => {
  const params = new URLSearchParams(queryString);
  const query: Record<string, string | string[]> = {};

  params.forEach((value, key) => {
    if (query[key]) {
      // 기존 값이 문자열이면 배열로 변환
      if (typeof query[key] === 'string') {
        query[key] = [query[key] as string, value];
      } else {
        (query[key] as string[]).push(value);
      }
    } else {
      query[key] = value;
    }
  });

  return query;
};
